import {
  getAttachmentMediaType,
  MAX_ATTACHMENT_BYTES,
  MAX_ATTACHMENTS,
  type SidekickAttachmentMediaType,
} from '../../utils/sidekickAttachments';

type PickedFile = {
  file: File;
  mediaType: SidekickAttachmentMediaType;
};

type PickAttachmentsResult = {
  picked: PickedFile[];
  error?: string;
};

const UNSUPPORTED_ERROR = `Some files weren’t attached. Attach images, PDFs, text or Excel files up to ${MAX_ATTACHMENT_BYTES / 1024 / 1024} MB.`;
const TOO_MANY_ERROR = `You can attach up to ${MAX_ATTACHMENTS} files.`;

/** Keeps the files the Sidekick accepts, up to the per-message limit. */
export const pickAttachments = (
  files: readonly File[],
  attachedCount: number,
): PickAttachmentsResult => {
  const supported = files.flatMap<PickedFile>((file) => {
    const mediaType = getAttachmentMediaType(file);
    return mediaType && file.size <= MAX_ATTACHMENT_BYTES
      ? [{ file, mediaType }]
      : [];
  });
  const picked = supported.slice(0, MAX_ATTACHMENTS - attachedCount);

  if (supported.length < files.length) {
    return { picked, error: UNSUPPORTED_ERROR };
  }
  if (picked.length < supported.length) {
    return { picked, error: TOO_MANY_ERROR };
  }

  return { picked };
};
